import React from 'react';

import './residentssay.scss'

const Residentssay = () =>
{
	return (
		<section className="testimonials-section">
			<div className="container">
				<div className="grid-layout">
					<div className="testimonial-header">
						{/*<span className="subtitle">Testimonials</span>*/}
						<h2 className="section-title">What Our Guests Say<br />
							जिथे घरासारखं वाटतं</h2>
						<div className="navigation-buttons">
							{/*<button className="nav-button">*/}
							{/*	<FaChevronLeft className="material-symbols-outlined" />*/}
							{/*</button>*/}
							{/*<button className="nav-button">*/}
							{/*	<FaChevronRight className="material-symbols-outlined" />*/}
							{/*</button>*/}
						</div>
					</div>

					<div className="testimonial-card">
						<div className="quote-icon">"</div>
						<p className="testimonial-text">
							"Very clean and well-maintained home stay. Great location and smooth booking experience. Highly recommended!"
						</p>
						<div className="author-info">
							<img className="author-avatar" src="https://randomuser.me/api/portraits/women/32.jpg" alt="Amit Patil" />
							<div>
								<h4 className="author-name">Dr Aishwarya</h4>
								<p className="author-title">Sangali</p>
							</div>
						</div>
					</div>

					<div className="testimonial-card testimonial-card-offset">
						<div className="quote-icon">"</div>

						<p className="testimonial-text">
							"Stay was very comfortable and peaceful. The farm stay environment was perfect for a relaxing weekend with family."
						</p>
						<div className="author-info">
							<img className="author-avatar" src="https://randomuser.me/api/portraits/men/32.jpg" alt="Priya Sharma" />
							<div>
								<h4 className="author-name">Kailash Borade</h4>
								<p className="author-title">Pune</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Residentssay;